module.exports = __webpack_public_path__ + "img/myh2.0db50ded.jpg";